/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { PasswordComplexityComponent } from './complexity/password-complexity.component';
import { BasePasswordFormComponent } from './forms/base-password-form.component';
import { ChangePasswordFormComponent } from './forms/change-password-form/change-password-form.component';
import { ResetPasswordFormComponent } from './forms/reset-password-form/reset-password-form.component';
import { ResetPasswordButtonComponent } from './reset-password-button/reset-password-button.component';
import { ChangePasswordDialogComponent } from './reset-password-dialog/change-password-dialog.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
    exports: [
        ResetPasswordComponent,
        ResetPasswordButtonComponent,
        ResetPasswordFormComponent,
        PasswordComplexityComponent
    ],
    imports: [

        ResetPasswordComponent,
        ResetPasswordButtonComponent,
        ChangePasswordDialogComponent,
        BasePasswordFormComponent,
        ResetPasswordFormComponent,
        ChangePasswordFormComponent,
        PasswordComplexityComponent
    ]
})
export class ResetPasswordModule {}
